import { push } from "connected-react-router";
import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { renewSession } from "auth/modules/actions";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/CreateOrganization";

export function* createOrganization(action: Actions.CreateOrganizationAction) {
    const { payload } = action;
    const { credentials, organization, redirectOnSuccess } = payload;
    const redirect = typeof redirectOnSuccess === "string";

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const org = yield api.createOrgs(organization);

        if (redirect) {
            yield put(push(`/${org.organizationId}`));
        }
        yield put(renewSession(0));
        yield put(Actions.createOrganizationEnd(undefined, org, redirect));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.createOrganizationEnd(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchCreateOrganization() {
    yield takeEvery(Actions.CREATE_ORGANIZATION, createOrganization);
}
